import { createSlice } from "@reduxjs/toolkit";
import { Prayer } from "../config";
import {
  doAddPrayer,
  doDelPrayer,
  doFetchPrayerList,
  doUpdatePrayer,
} from "./prayer.action";

interface Meta {
  totalItems: number;
  itemsPerPage: number;
  totalPages: number;
  currentPage: number;
}

interface PrayerState {
  prayers: Prayer[];
  searchQuery: string;
  meta: Meta | null;
  loading: boolean;
  error: string | null;
}

const initialState: PrayerState = {
  prayers: [] as Prayer[],
  searchQuery: "",
  meta: null,
  loading: false,
  error: null,
};

const prayerSlice = createSlice({
  name: "prayer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch list
    builder
      .addCase(doFetchPrayerList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doFetchPrayerList.fulfilled, (state, action) => {
        state.loading = false;
        state.prayers = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(doFetchPrayerList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // add prayer
    builder
      .addCase(doAddPrayer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doAddPrayer.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(doAddPrayer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // update
    builder
      .addCase(doUpdatePrayer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doUpdatePrayer.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        const index = state.prayers.findIndex(
          (prayer) => prayer.pmid === action.payload.id
        );

        if (index !== -1) {
          state.prayers[index] = {
            ...state.prayers[index],
            ...action.payload.data,
            prayerCategory: action.payload.data.pcid ? {
              pcid: action.payload.data.pcid,
              title: '' // You might need to get the category title from somewhere
            } : null
          };
        }
      })
      .addCase(doUpdatePrayer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // delete category
    builder
      .addCase(doDelPrayer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doDelPrayer.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        state.prayers = state.prayers.filter(
          (prayer) => prayer.pmid !== action.meta.arg
        );
        if (state.meta) {
          state.meta.totalItems -= 1;
        }
      })
      .addCase(doDelPrayer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default prayerSlice.reducer;
